<template>
  <div class="columns is-multiline">

    <section class="hero is-warning is-bold is-small column is-12 m-t-45">
      <div class="hero-body">
        <h1 class="title">
          Hola, {{ $session.get('user').name }}.
        </h1>
        <h2 class="subtitle">
          ¡Espero que tengas un gran dia!
        </h2>
      </div>
    </section>
    <section v-if="!$session.get('user').admin" class="info-tiles column is-12">
      <div class="tile is-ancestor has-text-centered">
        <div v-if="$session.get('user').transaction" class="tile is-parent">
          <article class="tile is-child box" style="cursor: pointer;" @click="goTo('output')">
            <p class="title">Proveedor</p>
          </article>
        </div>
        <div v-if="$session.get('user').transactionEducational" class="tile is-parent">
          <article class="tile is-child box" style="cursor: pointer;" @click="goTo('output-educational')">
            <p class="title">Responsable Financiero</p>
          </article>
        </div>
      </div>
    </section>
    <section v-if="$session.get('user').admin" class="info-tiles column is-12">
      <div class="tile is-ancestor has-text-centered">
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ balance.cali }}</p>
            <p class="subtitle">Cali</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ balance.yumbo }}</p>
            <p class="subtitle">Yumbo</p>
          </article>
        </div>
        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="title">{{ balance.jamundi }}</p>
            <p class="subtitle">Jamundi</p>
          </article>
        </div>
      </div>
    </section>
    <div v-if="$session.get('user').admin" class="column is-12">
      <div class="card events-card">
        <header class="card-header">
          <p class="card-header-title">
            Cuentas sin municipio
          </p>
        </header>
        <div class="card-table">
          <div class="content">
            <table class="table is-fullwidth is-striped">
              <tbody >
                <tr v-for="row in data" :key="row.id">
                  <td width="5%"><i class="fa fa-bell-o"></i></td>
                  <td>{{ row.account }}</td>
                  <td>{{ row.description }}</td>
                  <td><a class="button is-small is-warning" @click="goTo('account/' + row.id)">Actualizar</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <footer class="card-footer">
          <a @click="goTo('account')" class="card-footer-item">Ver Todos</a>
        </footer>
      </div>
    </div>
    <div v-if="$session.get('user').admin" class="column is-12">
      <div class="card events-card">
        <header class="card-header">
          <p class="card-header-title">
            Estudiantes sin responsable financiero
          </p>
        </header>
        <div class="card-table">
          <div class="content">
            <table class="table is-fullwidth is-striped">
              <tbody >
                <tr v-for="(row, index) in dataEducational" :key="'Ed ' + row.doc_student + '-' + row.archive_id + '-' + row.oc_code">
                  <td width="5%"><i class="fa fa-bell-o"></i></td>
                  <td>{{ row.initial_date }} to {{ row.final_date }}</td>
                  <td>{{ row.doc_student }}</td>
                  <td>{{ row.name_student }}</td>
                  <td>{{ row.oc_code + ' - ' + row.oc_name }}</td>
                  <td><a class="button is-small is-warning" @click="openModalEducational(index)">Actualizar</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- modal -->
    <b-modal
      :active.sync="isCardModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Example Modal"
      close-button-aria-label="Close"
      aria-modal
    >
      <form action="">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Editando Estudiante
              <br>
              {{ dataEdit.data.doc_student }} - {{ dataEdit.data.name_student }}
            </p>
          </header>
          <section class="modal-card-body">
            <div class="card-content">
              <div class="columns is-multiline">
                <b-field label="Documento Responsable Financiero*" class="column is-12">
                  <b-input v-model="dataEdit.doc_tutor"></b-input>
                </b-field>
                <b-field class="column is-12" label="Nombre Responsable Financiero*">
                  <b-input v-model="dataEdit.name_tutor"></b-input>
                </b-field>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button
                label="Cancelar"
                @click="isCardModalActive = false" />
            <b-button
                label="Guardar"
                type="is-success"
                @click="save()" />
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
import AccountsService from '@/services/AccountsService'
import TransactionsEducationalService from '@/services/TransactionsEducationalService'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
  },
  data () {
    return {
      data: [],
      dataEducational: [],
      balance: {
        cali: 0,
        yumbo: 0,
        jamundi: 0
      },
      isCardModalActive: false,
      dataEdit: {
        data: {},
        doc_tutor: '',
        name_tutor: ''
      }
    }
  },
  mounted () {
    if (this.$session.get('user').admin) {
      this.fetchBalance()
      this.fetchData()
      this.fetchDataEducational()
    }
  },
  methods: {
    async fetchData () {
      var accounts = await AccountsService.fetchAccounts2(this.$session.get('user').token)
      for (var i = 0; i < accounts.data.length; i++) {
        this.data.push(accounts.data[i])
      }
    },
    async fetchDataEducational () {
      var transactions = await TransactionsEducationalService.fetch2(this.$session.get('user').token)
      for (var i = 0; i < transactions.data.length; i++) {
        this.dataEducational.push(transactions.data[i])
      }
    },
    async fetchBalance () {
      var response = await AccountsService.balance(this.$session.get('user').token)
      this.balance.cali = response.data.cali
      this.balance.jamundi = response.data.jamundi
      this.balance.yumbo = response.data.yumbo
    },
    openModalEducational (index) {
      this.dataEdit = {
        data: this.dataEducational[index],
        doc_tutor: '',
        name_tutor: ''
      }
      this.isCardModalActive = true
    },
    async save () {
      if (this.dataEdit.doc_tutor === null || this.dataEdit.doc_tutor === '') {
        this.alert('danger', 'Documento del responsable financiero es requerido')
        return false
      }
      if (this.dataEdit.name_tutor === null || this.dataEdit.name_tutor === '') {
        this.alert('danger', 'Nombre del responsable financiero es requerido')
        return false
      }
      var response = {}
      // POST
      response = await TransactionsEducationalService.editTransaction(
        {
          doc_student: this.dataEdit.data.doc_student,
          oc_code: this.dataEdit.data.oc_code,
          archive_id: this.dataEdit.data.archive_id,
          doc_tutor: this.dataEdit.doc_tutor,
          name_tutor: this.dataEdit.name_tutor
        },
        this.$session.get('user').token
      )
      if (response.data.success) {
        this.$toast.open({
          message: 'Estudiante actualizado',
          type: 'is-success'
        })
        this.isCardModalActive = false
        this.dataEducational = []
        this.fetchDataEducational()
      } else {
        this.alert('danger', 'Error, no se pudo crear la cuenta')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/home/Dashboard.vue